$(document).on('turbolinks:load', function() {
  $('#segmentSelect').change(function(){
    let url = new URL(window.location.href);

    if($(this).val()){
      var val = $(this).val()
      url.searchParams.set('segment_id', val)

    } else {
      url.searchParams.delete('segment_id')
    }

    window.location.href = url.href;
  });

  $('#projectSelect').change(function(){
    let url = new URL(window.location.href);

    if($(this).val()){
      var val = $(this).val()
      url.searchParams.set('project_id', val)

    } else {
      url.searchParams.delete('project_id')
    }

    window.location.href = url.href;
  });
});
